import { SVGProps } from "react";

export const LongArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.25003 13.25L1.25003 7M1.25003 7L6.25003 0.750001M1.25003 7L18.75 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
